<template>
  <el-form ref="formOption" class="yk-multiselect" label-width="70px">
    <el-row>
      <el-col :span="22" :offset="1">
        <el-form-item label="题目：">
            <div v-if="IsTitle">
              <Editor placeholder="请输入内容" />
            </div>
            <div v-else>
              {{cont.ContentText}}
            </div>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col v-if="IsSelects" :span="15" :offset="1">
        <el-form-item label="选项：">
          <el-form-item label-width="30px" v-for="(question,index) in questions" :key="question">
            <el-checkbox-group v-model="check" >
              <el-checkbox :label="question.choice" @change="addCheckValue"></el-checkbox>
              <el-input placeholder="请输入选项内容" style="width: 90%;margin-top:10px;"></el-input>
              <i class="el-icon-close" @click="closeChoice(index)"></i>
            </el-checkbox-group>
          </el-form-item>
        </el-form-item>
        <span @click="addChoice" class="yk-addChoice">
          <i class="el-icon-circle-plus"></i>
          添加选项
        </span>
      </el-col>
      <el-col v-else :span="15" :offset="1">
        <el-form-item label="选项：">
          <el-form-item  v-for="(question,index) in questions" :key="question">
              <span>{{alphabet[index]}}.</span>
              <span>{{question}}</span>
          </el-form-item>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-show="IsAnswers && isBook">
      <el-col :span="22" :offset="1">
        <el-form-item label="答案：">
          <span v-for="CheckValue in CheckValues" :key="CheckValue">{{CheckValue}}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-show="IsAnalysis != 0 && isBook">
      <el-col :span="22" :offset="1">
        <el-form-item label="解析：">
            <Editor v-if="IsAnalysis > 0" placeholder="请输入内容" />
            <span v-else>{{data.Analysis}}</span>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import Vue from 'vue';
export default {
  name: "multiselects",
  props:{
    isBook:{
      type: Boolean,
      default: true
    },
    IsTitle: {
      type: Boolean,
      default: true
    },
    IsSelects: {
      type: Boolean,
      default: true
    },
    IsAnswers: {
      type: Boolean,
      default: true
    },
    IsAnalysis: {
      type: Number,
      default: 0
    },
    data: {
      type: Object,
      default: function(){
        return {}
      }
    }
  },
  created(){
    this.cont=this.data;
    this.questions = this.data.Selects;
    this.CheckValues= this.data.Answers;
    this.content = this.data.Analysis;
  },
  data() {
    return {
      cont:[],
      content: '请输入内容',
      formOption:{
        choice:null,
      },
      questions:[{
        id:0,
        choice:'A',
        contrary:false
      },{
        id:1,
        choice:'B',
        contrary:false
      },{
        id:2,
        choice:'C',
        contrary:false
      },{
        id:3,
        choice:'D',
        contrary:false
      }],
      a:1,
      CheckValues:[],
      check:[],
      alphabet:['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],
    };
  },
  watch:{
    check(){
      console.log(this.check)
    }
  },
  methods: {
      // 添加选项
    addChoice: function() {
      var n=this.questions.length;
      var str={id:n,contrary:false,choice:this.alphabet[n]};
      this.questions.push(str);
      this.CheckValues.push(null);
    },
    // 删除选项
    closeChoice: function(index) {
      for (var i = 0; i <= index; i++) {
        this.questions[i].choice=this.alphabet[i];
      }
      this.questions.splice(index,1);
      this.CheckValues=this.check;

    },
    // 添加正确答案
    addCheckValue:function(){
      this.CheckValues=this.check;
    },

  }
};
</script>

<style lang="scss" scoped>
@import "~theme/page/components/variables.scss";
.yk-multiselect{

  .el-form-item .el-form-item{
    margin-bottom: 20px;
  }
  .el-input{
    width: 85%;
    margin-left: 15px;
  }
  i.el-icon-close{
    font-size: 15px;
    margin-left: 10px;
  }

  .el-col .yk-addChoice{
    margin-left: 70px;
    color: #606266;
  }
}

</style>

